import { vncConnectionOf } from "../pages/server/console/connection.js";
import { rdpConnectionOf } from "../rdp/connection.js";
import { closeTerminal, connectionOf } from "./connections.js";
import { kindOf, terminals } from "./store.js";

/*
 * What a tab's menu and the toolbars do to a session, whatever its kind
 * (docs/terminal.md, "Session window").
 */

/**
 * A new session on the same tab. A remote desktop asks for the password
 * again (it is never kept): reconnecting ends it and shows the sign-in.
 */
export function reconnectSession(id: string): void {
  const tab = terminals.tab(id);
  if (!tab) return;
  const kind = kindOf(tab);
  if (kind === "rdp") rdpConnectionOf(id)?.end();
  else if (kind === "vnc") void vncConnectionOf(id)?.connect();
  else void connectionOf(id)?.connect();
}

/** Ends the connection and keeps the tab. */
export function disconnectSession(id: string): void {
  const tab = terminals.tab(id);
  if (!tab || tab.status !== "connected") return;
  const kind = kindOf(tab);
  if (kind === "rdp") rdpConnectionOf(id)?.end();
  else if (kind === "vnc") vncConnectionOf(id)?.disconnect();
  else connectionOf(id)?.disconnect();
}

export const closeSession = closeTerminal;

/** «Закрыть другие»: every tab but this one. */
export function closeOtherSessions(id: string): void {
  for (const tab of terminals.snapshot().tabs) if (tab.id !== id) closeTerminal(tab.id);
}
